import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";

const initialState = {
    list: {
        bom: {},
        isLoading: false,
        error: "",
        groupedComponent: {},
        receiveFormChange: false,
        inFabrication: false,
        packageMaterialId: '',
        bomAttachment: '',
        isRevised: false,
        status: null,
        pdfUrl: "",
        hangerCoverSheet: null,
        pushToFabKeys: {},
    }
}

const namespacers = {
    receivedBom: createNamespacer("SET_RECEIVED_BOMS"),
}

const receivedBomReducer = createReducer(initialState.list, {
    [namespacers.receivedBom("SET_RECEIVED")]: (state, action) => {

        let grouped = {}

        grouped = { ...state.groupedComponent }

        grouped[action.payload.id] = {
            ...grouped[action.payload.id],
            'received': action.payload.received,
            'back_order': action.payload.backOrder,
            'rejected_qty': action.payload.rejected_qty,
            quantity: action.payload.quantity,
        }

        return {
            ...state,
            groupedComponent: { ...grouped },
            receiveFormChange: true
        }

    },

    [namespacers.receivedBom("SET_RECEIVED_ALL")]: (state, action) => {
        let grouped = {}
        const newBom = {}

        for (const name in state.bom) {
            const isPipeOrAdditional = name === 'Pipe' || name === 'Additional Material'
            newBom[name] = state.bom[name].map((item) => {
                return Object.keys(item).map((key) => {
                    return item[key].map(item => {
                        grouped[item.id] = {
                            received: isPipeOrAdditional ? item.length : item.quantity,
                            back_order: 0,
                            rejected_qty: item.rejected_qty
                        }
                        if (isPipeOrAdditional) {
                            item.received = item.length;
                        } else {
                            item.received = item.quantity;
                        }
                        return item
                    })
                })
            })
        }

        return {
            ...state,
            groupedComponent: { ...grouped }
        }
    },

    [namespacers.receivedBom("CLEAR_FORM")]: (state, action) => {
        return {
            ...state,
            groupedComponent: {
                ...initialState.list.groupedComponent,
            },
            receiveFormChange: false
        }
    },

    [namespacers.receivedBom("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },

    [namespacers.receivedBom("SET_BOM")]: (state, action) => {
        return {
            ...state,
            bom: action.payload.value,
        }
    },

    [namespacers.receivedBom("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },

    [namespacers.receivedBom("SET_RECEIVE_NOTE")]: (state, action) => {
        let grouped = {}

        grouped = { ...state.groupedComponent }

        grouped[action.payload.id] = {
            ...grouped[action.payload.id],
            'receive_note_attributes': {
                'content': action.payload.value,
                'context': 'receive',
            }
        }
        return {
            ...state,
            groupedComponent: { ...grouped },
            receiveFormChange: true
        }
    },
    [namespacers.receivedBom("SET_PACKAGE_MATERIAL_ID")]: (state, action) => {
        return {
            ...state,
            packageMaterialId: action.payload.value,
        }
    },
    [namespacers.receivedBom("SET_IN_FABRICATION")]: (state, action) => {
        return {
            ...state,
            inFabrication: action.payload.value,
        }
    },
    [namespacers.receivedBom("SET_IS_REVISED")]: (state, action) => {
        return {
            ...state,
            isRevised: action.payload.value,
        }
    },
    [namespacers.receivedBom("SET_BOM_ATTACHMENT")]: (state, action) => {
        return {
            ...state,
            bomAttachment: action.payload.value,
        }
    },
    [namespacers.receivedBom("SET_HANGER_COVERSHEET")]: (state, action) => {
        return {
            ...state,
            hangerCoverSheet: action.payload.value,
        }
    },
    [namespacers.receivedBom("SET_PUSH_TO_FAB_KEYS")]: (state, action) => {
        return {
            ...state,
            pushToFabKeys: {
                packageId: action.payload.packageId,
                shopPosition: action.payload.shopPosition,
                packageMaterialId: action.payload.packageMaterialId,
                fabDateCheck: action.payload.fabDateCheck,
                onHoldCheck: action.payload.onHoldCheck,
                addToPriorityCheck: action.payload.addToPriorityCheck,
                packageMaterialName: action.payload.packageMaterialName,
            },
        }
    },
    [namespacers.receivedBom("SET_STATUS")]: (state, action) => {
        return {
            ...state,
            status: action.payload.value,
        }
    },
    [namespacers.receivedBom("SET_PDF_URL")]: (state, action) => {
        return {
            ...state,
            pdfUrl: action.payload.value,
        }
    }

})

const reducer = combineReducers({
    list: receivedBomReducer,
})

export default reducer;